module.exports = __webpack_public_path__ + "img/exterior_11.cff329c7.jpg";